import React										from 'react';

import Icon											from '../ressources/components/Icon';

import {useAppSelector}								from '../app/hooks';

import img_hourglass								from '../ressources/images/icon/hourglass.svg';

import LANGUAGE										from '../ressources/language';

import './Devices.css';

function DevicesHistorical() {
	const lang = useAppSelector(state => state.settings.lang);

	const TEXTE = LANGUAGE(lang);

	return (
		<div className={'deviceDocumentsHistorical'}>
			<Icon
				size={40}
				iconBorder
				iconSize={20}
				borderSize={8}
				icon={img_hourglass}
			/>
			<span>{TEXTE.devices.soon}</span>
			<span>{TEXTE.devices.soonText}</span>
		</div>
	);
}

export default DevicesHistorical;
